var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22656 13.3546V9.48459C5.22656 5.74459 8.25656 2.70459 12.0066 2.70459C15.7465 2.70459 18.7866 5.73459 18.7866 9.48459V14.1646V16.0645C18.7866 18.1945 17.0665 19.9146 14.9365 19.9146H10.3466",
    stroke: "#00346B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58532 15.3051C2.68532 15.3051 1.94531 14.5751 1.94531 13.6652V10.6651C1.94531 9.76514 2.67532 9.02515 3.58532 9.02515C4.48532 9.02515 5.22532 9.75514 5.22532 10.6651V13.6652C5.22532 14.5751 4.48532 15.3051 3.58532 15.3051Z",
    stroke: "#00346B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4158 15.3051C19.5158 15.3051 18.7758 14.5751 18.7758 13.6652V10.6651C18.7758 9.76514 19.5057 9.02515 20.4158 9.02515C21.3158 9.02515 22.0557 9.75514 22.0557 10.6651V13.6652C22.0557 14.5751 21.3158 15.3051 20.4158 15.3051Z",
    stroke: "#00346B",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5253 21.2947H10.2253C9.46534 21.2947 8.84534 20.6746 8.84534 19.9147C8.84534 19.1546 9.46534 18.5347 10.2253 18.5347H11.5253C12.2854 18.5347 12.9053 19.1546 12.9053 19.9147C12.9053 20.6746 12.2854 21.2947 11.5253 21.2947Z",
    fill: "#00346B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.b65772c792eb3881615ef2fcf82150d1.svg";
export { ForwardRef as ReactComponent };